import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import autobind from 'autobind-decorator';
import { Link } from 'react-router-dom';

import { DataTableView, Column } from 'src/core/ui/data-table.view';
import { OptionsDialogView } from 'src/core/ui/options-dialog.view';
import { DropdownView } from 'src/core/ui/dropdown.view';
import { RegionEditorController } from 'src/app/general/regions/parts/region-editor.controller';

@observer
export class PlaceListView extends React.Component<PlaceListViewProps, any> {
	@observable
	showDialog = false;

	constructor(props: any) {
		super(props);
	}

	@autobind
	private createNew() {
		this.showDialog = true;
		return Promise.resolve(null);
	}

	@autobind
	private closeDialog(selectedValue?: string) {
		if (selectedValue) {
			this.props.onItemDoubleClicked('new', selectedValue);
		}
		this.showDialog = false;
	}
	@autobind
	getType(type: number) {
		switch (type) {
			case 0:
				return 'General';
			case 1:
				return 'Airport';
			case 2:
				return 'Resort';
			case 3:
				return 'TransferPoint';
			case 4:
				return 'CoachPickupPoint';
		}
	}
	render() {
		const model = this.props.model;
		const items = model.items.map(o => o);
		const columns: Column[] = [
			{
				key: 'displayName',
				title: 'Name',
				dataIndex: 'displayName',
				render: (text, record: PlaceSummary) => <Link to={`/general/places/${record.id}/${this.getType(record.type)}`}>{text}</Link>,
			},
			{
				key: 'regionName',
				title: 'Region',
				dataIndex: 'regionName',
				filter: {
					field: 'regionId',
					type: 'foreignKey',
					render: (value, onChange) => (
						<RegionEditorController
							label={null}
							mode='edit'
							value={value}
							onChanged={(newValue) => { onChange(newValue != null ? newValue.id : null); }}
							setBusy={this.props.setBusy}
						/>
					)
				}
			},
			{
				key: 'type',
				title: 'Type',
				dataIndex: 'typeText',
				filter: {
					field: 'type',
					type: 'foreignKey',
					render: (value, onChange) => (
						<DropdownView
							label={null}
							model={value}
							onChanged={(item) => { onChange(item != null ? item.value : null); }}
							options={
								[
									{ value: 0, label: 'General' },
									{ value: 1, label: 'Airport' },
									{ value: 2, label: 'Resort' },
									{ value: 3, label: 'Transfer Point' },
									{ value: 4, label: 'Coach Pickup Point' },
								]
							}
						/>
					)
				}
			}
		];

		return (
			<div className="window window-normal">
				<OptionsDialogView
					closeDialog={this.closeDialog}
					options={[
						{
							key: 'General',
							text: 'General',
							checked: true
						},
						{
							key: 'Airport',
							text: 'Airport'
						}
						,
						{
							key: 'Resort',
							text: 'Resort'
						}
						,
						{
							key: 'TransferPoint',
							text: 'Transfer Point'
						}
						,
						{
							key: 'CoachPickupPoint',
							text: 'Coach Pickup Point'
						}
					]}
					showDialog={this.showDialog}
					title='Choose a type'
					subtitle='You can choose between general places or specify an airport.'
				/>

				<div className="panel">
					<DataTableView
						setBusy={this.props.setBusy}
						columns={columns}
						model={model}
						createNewItem={this.createNew}
						itemDoubleClick={(item) => { if (this.props.onItemDoubleClicked) { this.props.onItemDoubleClicked(item, this.getType(item.type)); } }}
						hierarchyParent={['parentPlaceId']}
						hierarchyHasChildren={(item) => item.hasChildren}
						hierarchyId={['id']}
					/>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/places/list/place-list.view.tsx